export default __webpack_public_path__ + "static/media/en.bad67634.svg";